<template>
  <base-section id="theme-features">
    <base-section-heading title="HEQ Products" />

    <v-container>
      <v-row>
        <v-col
          v-for="(feature, i) in features"
          :key="i"
          cols="12"
          md="6"
        >
          <router-link
            style="text-decoration: none; color: inherit;"
            :to="{
              name: feature.routeName,
              params: {'loanConfiguration': feature.loanConfiguration}
            }"
            class="d-block"
          >
            <base-avatar-card
              v-bind="feature"
              align="left"
              horizontal
            >
              {{ feature.description }}
            </base-avatar-card>
          </router-link>
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionHeqProducts',

    data: () => ({
      features: [
        {
          title: 'Loan Application',
          icon: 'mdi-fountain-pen-tip',
          description: 'Apply now with our streamlined loan application and receive an approval in minutes.',
          routeName: 'Loan Application',
        },
        {
          title: 'Create a Loan Estimate',
          icon: 'mdi-clipboard-text',
          description: 'See what an HEQ powered loan can do for you.',
          routeName: 'Loan Estimate',
          loanConfiguration: {
            term: 30,
            otherTerm: 30,
            deferredYears: 5,
            rate: 2,
            otherRate: 3.75,
            otherHeqLoanMonthlyPayment: 0,
            otherHeqLocMonthlyPayment: 0,
            loanAmountBase: 0,
          },
        },
        {
          title: 'Loan Calculator',
          icon: 'mdi-compare',
          description: 'Pinpoint your financial future.',
          routeName: 'Loan Calculator',
        },
        {
          title: 'Loan Products',
          icon: 'mdi-cellphone',
          description: 'Take an in depth look at our HEQLOAN, HEQLOC and Reverse HEQ Mortgage.',
          routeName: 'Products',
        },
        {
          title: 'Equity Banking',
          icon: 'mdi-home-analytics',
          description: 'Explore staking options for generating passive income from your home.',
          routeName: 'Staking Estimate',
        },
      ],
    }),
  }
</script>
